import * as config from "@/config";
import Axios from "axios";

var axios = Axios.create({
	baseURL: config.BASE_URL
});

export default {
	SHOW_ALERT: ({ commit }, payload) => {
		commit("showAlert", payload);
	},
	UPLOAD_MEDIA({ commit }, formData) {
		return axios
			.post("/infringement-service/external/v1.0.0/fileUpload", formData)
			.then(response => {
				return response.data;
			})
			.then(data => {
				if (typeof data === "object" && data.statusCode === 200 && data.response.filename) {
					return data.response;
				} else {
					throw new Error("Upload failed");
				}
			})
			.catch(({ message }) => {
				commit("showAlert", { text: "Upload failed" });
				throw new Error(message);
			});
	},
	SUBMIT_COPYRIGHT_CLAIM({ commit }, params) {
		return axios
			.post("/infringement-service/external/v1.0.0/reportInfringement", { params })
			.then(response => {
				return response.data;
			})
			.then(data => {
				if (typeof data === "object") {
					commit("showAlert", { text: data.response.message });
					return data;
				} else {
					throw new Error("Submission failed");
				}
			})
			.catch(err => {
				commit("showAlert", { text: err.response.data.errMsg });

				throw new Error(err.response.data.errMsg);
			});
	}
};
